import {Totals} from '../../../../../common/components/Totals/Totals';
import React from 'react';
import {TotalsSectionDataHooks} from '../TotalsSection';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import {isFreeShippingCoupon} from '../../../../../domain/utils/total.util';
import {TotalUpdateSkeleton} from '../../TotalUpdateSkeleton';

export const DeliveryTotalsRow = () => {
  const localeKeys = useLocaleKeys();
  const {cartSummary, cart, isCartSummaryUpdating} = useControllerProps().checkoutStore;

  if (!cart.hasShippableItems) {
    return null;
  }

  const getShippingRowTitleText = (): string => {
    return cartSummary?.deliverySummary?.method?.pickup
      ? localeKeys.checkout.orderSummary.totals.pickup.label()
      : localeKeys.checkout.order_summary.totals.delivery();
  };

  const shouldDisplayNoAmount = !cartSummary?.deliverySummary?.method;

  const getShippingRowValueText = (): string => {
    if (shouldDisplayNoAmount) {
      return localeKeys.checkout.summary.shipping.noAmount();
    }

    if (
      cartSummary.priceSummary.delivery.amount === 0 ||
      (cartSummary.couponDiscount && isFreeShippingCoupon(cartSummary.couponDiscount))
    ) {
      return localeKeys.checkout.order_summary.totals.free();
    }
    return cartSummary.priceSummary.delivery.formattedAmount;
  };

  return (
    <Totals.TotalsRow
      dataHook={TotalsSectionDataHooks.ShippingRow}
      title={getShippingRowTitleText()}
      value={() =>
        isCartSummaryUpdating ? (
          <TotalUpdateSkeleton />
        ) : (
          <Text
            data-hook={TotalsSectionDataHooks.ShippingRowValue}
            aria-label={shouldDisplayNoAmount ? localeKeys.checkout.orderTotal.noShipping.ariaLabel() : undefined}>
            {getShippingRowValueText()}
          </Text>
        )
      }
    />
  );
};
